import React from 'react';
import { connect } from 'react-redux';

const ImportEmployeeRow = ({ item }) => {
    if (item.error) {
        return (
            <tr key={item.rowNumber}>
                <td>{item.rowNumber}</td>
                <td>
                    {item.error.message}
                </td>
            </tr>
        )
    }
    if (item.warnings) {
        return (
            item.warnings.map((i, warningNumber) => {
                return (
                    <tr key={warningNumber}>
                        <td>{item.rowNumber}</td>
                        <td>{i.message}</td>
                    </tr>
                )
            })
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ImportEmployeeRow)